// Conteúdo do nicho "Clínica de Estética". Mesma estrutura de barbearia.js —
// ver src/content/niches/index.js para como o nicho ativo é escolhido.
export default {
  slug: 'clinica-de-estetica',
  navLabel: 'Clínica de Estética',

  // 'light' = header, hero e rodapé em tom claro (mais aberto, combina mais
  // com o nicho); 'dark' (padrão) é o visual escuro original. Ver uso em
  // LandingHeader.vue, LandingHero.vue e LandingFooter.vue.
  theme: 'light',

  seo: {
    title: 'Avance Clínicas de Estética - Sistema de Gestão para Clínicas de Estética',
    description:
      'Agenda online, comissão dos profissionais e financeiro em um só lugar. Sistema de gestão feito para clínicas de estética de todos os tamanhos.',
  },

  whatsappMessage: 'Olá! Quero conhecer o Avance para a minha clínica de estética.',
  footerTagline: 'Sistema de gestão feito para clínicas de estética.',

  // Card curto usado em LandingSegmentSwitcher.vue (seção "veja adaptado ao
  // seu segmento", antes do CTA intermediário).
  segmentCard: {
    desc: 'Procedimentos, anamnese e retorno de clientes.',
  },

  hero: {
    eyebrow: 'Feito para clínica de estética',
    title: 'Tenha uma clínica de estética organizada, lucrativa e com a agenda sempre cheia.',
    subtitle:
      'Agendamento online, gestão financeira, comissão automática, controle da equipe e atendimento em um único sistema, desenvolvido para clínicas de estética.',
    primaryCta: 'Comece agora',
  },

  heroMock: {
    badgeLabel: 'Agenda de hoje',
    revenueLabel: 'Faturamento do dia',
    revenueValue: 'R$ 1.240',
    rows: [
      { time: '09:00', initials: 'PL', client: 'Patrícia Lima', service: 'Limpeza de Pele', color: 'linear-gradient(135deg,#ff4d18,#c22700)' },
      { time: '10:30', initials: 'RC', client: 'Renata Costa', service: 'Drenagem', color: 'linear-gradient(135deg,#a6d33c,#6a8a1f)' },
      { time: '11:15', initials: 'FM', client: 'Fernanda Melo', service: 'Peeling', color: 'linear-gradient(135deg,#f6b29c,#a83b21)' },
    ],
  },

  trustBadges: [
    { label: 'Acesso pelo celular ou computador', icon: 'M8 3h8a2 2 0 012 2v14a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2zm4 15h.01' },
    { label: 'Seus dados salvos na nuvem, sem risco de perder', icon: 'M7 16a4 4 0 01-.88-7.9A5.5 5.5 0 0117.5 8H18a3.5 3.5 0 010 7H7z' },
  ],

  painPoints: {
    eyebrow: 'A rotina que você já conhece',
    title: 'Os problemas da sua clínica não estão na sala de atendimento. Estão na gestão.',
    items: [
      { title: 'Agenda desorganizada', desc: 'Pacientes marcam por WhatsApp e horários acabam se perdendo.' },
      { title: 'Caixa sem controle', desc: 'Fechamento manual e dificuldade para saber o lucro do dia.' },
      { title: 'Comissões demoradas', desc: 'Horas somando procedimentos e conferindo valores no fim do mês.' },
      { title: 'Pacientes que nunca voltam', desc: 'Sem histórico e sem lembretes, muitos simplesmente desaparecem.' },
    ],
  },

  screensPreview: {
    eyebrow: 'Veja por dentro',
    title: 'Sua agenda e seu financeiro organizados em telas simples de usar',
  },

  featureGridSection: {
    eyebrow: 'Funcionalidades',
    title: 'Tudo que sua clínica precisa pra rodar sem sustos',
  },

  features: [
    {
      title: 'Agenda em lista, kanban e calendário',
      desc: 'Veja os horários do jeito que fizer sentido para o seu dia: lista simples, kanban arrastando o paciente entre status ou calendário por mês, semana e dia.',
      icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    },
    {
      title: 'Agendamento online para o paciente',
      desc: 'Um link só da sua clínica onde o paciente escolhe profissional, procedimento e o horário, sem precisar te chamar no WhatsApp.',
      icon: 'M13 7l5 5m0 0l-5 5m5-5H6',
    },
    {
      title: 'Comissão automática por profissional',
      desc: 'Cada procedimento já entra na conta certa. No fim do mês, o valor de cada profissional está pronto, sem calculadora.',
      icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    },
    {
      title: 'Dashboard com KPIs da clínica',
      desc: 'Atendimentos do dia, receita, ticket médio e quais procedimentos mais dão lucro — tudo em gráficos, sem precisar somar nada.',
      icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    },
    {
      title: 'Cupons e programa de fidelidade',
      desc: 'Dê motivo pro paciente voltar: cupons de desconto e um programa de fidelidade ligado ao histórico de visitas dele.',
      icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    },
    {
      title: 'Vendas e estoque de produtos',
      desc: 'Cosméticos, descartáveis, produtos pós-procedimento — controle o estoque e registre a venda direto no atendimento, com as formas de pagamento que você usa.',
      icon: 'M16 11V7a4 4 0 00-8 0v4M5 9h14l1 11H4L5 9z',
    },
    {
      title: 'Múltiplas unidades numa conta só',
      desc: 'Rede com mais de uma clínica? Acompanhe todas as unidades a partir de um único painel, sem trocar de sistema.',
      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    },
    {
      title: 'Acesso por papel e LGPD',
      desc: 'Admin, recepcionista, esteticista e paciente veem só o que precisam ver. Exportação e exclusão de dados pessoais, conforme a LGPD.',
      icon: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    },
  ],

  whatsappNotifications: {
    eyebrow: 'Notificações automáticas',
    title: 'Confirmação e lembrete de horário pelo WhatsApp da sua clínica',
    paragraphs: [
      'Usamos a API do WhatsApp Business exclusivamente para notificações transacionais automáticas dos agendamentos dos pacientes finais de cada clínica: confirmação, lembrete e cancelamento de horário marcado.',
      'Cada clínica conecta o próprio número do WhatsApp através do fluxo oficial de Embedded Signup da Meta, diretamente na plataforma. As mensagens são enviadas usando modelos pré-aprovados pela Meta. Os pacientes finais podem cancelar o recebimento a qualquer momento.',
    ],
    mock: {
      businessName: 'Clínica Bella Estética',
      clientName: 'Patrícia',
      service: 'Limpeza de Pele',
      time: '10:30',
    },
  },

  bookingShowcase: {
    eyebrow: 'Agendamento online',
    title: 'Seus pacientes marcam procedimentos pelo celular, sem WhatsApp',
    desc:
      'Cada clínica recebe um link próprio de agendamento. O paciente escolhe a unidade, o profissional, o procedimento, o dia e o horário — em poucos passos, direto do celular. Você só olha a agenda já preenchida.',
    steps: ['Unidade', 'Profissional', 'Procedimentos', 'Data', 'Horário', 'Identificação', 'Resumo'],
    bullets: [
      'Link exclusivo da sua clínica, fácil de colocar no Instagram ou no WhatsApp',
      'Paciente também acompanha e cancela agendamentos pelo portal dele',
      'Cada profissional só aparece nos horários em que está disponível',
    ],
    mock: {
      primary: { name: 'Limpeza de Pele', duration: '60 min', price: 'R$ 180' },
      secondary: { name: 'Massagem Relaxante', duration: '50 min', price: 'R$ 120' },
      cta: 'Continuar',
    },
  },

  financeShowcase: {
    eyebrow: 'Financeiro',
    title: 'Fechamento de caixa e comissão sem sentar com a calculadora',
    desc:
      'Contas a pagar e a receber, visão geral do financeiro e comissão de cada profissional calculada automaticamente a partir dos atendimentos e vendas do mês. Relatórios exportáveis para conferir quando quiser.',
    bullets: [
      'Regra de comissão configurável por profissional',
      'Contas a pagar e a receber num só lugar',
      'Relatórios exportáveis para contabilidade',
    ],
  },

  loyaltyShowcase: {
    eyebrow: 'Fidelização',
    title: 'Dê ao paciente um motivo pra sempre voltar na sua clínica',
    desc:
      'Cupons de desconto e um programa de fidelidade conectado ao histórico de cada paciente ajudam a trazer de volta quem sumiu e a premiar quem já é fiel à clínica.',
    bullets: [
      'Cupons para primeira visita, aniversário ou indicação',
      'Pontos ou selos de fidelidade por visita',
      'Histórico de atendimentos por paciente, sempre à mão',
    ],
    mock: { badgeLine: 'Programa de fidelidade', progressText: '6 de 10 procedimentos — falta pouco!', total: 10, current: 6 },
  },

  audienceSection: {
    eyebrow: 'Para quem é',
    title: 'De um consultório só a uma rede de unidades',
  },

  audiences: [
    {
      title: 'Clínica solo',
      desc: 'Você atende e ainda organiza tudo sozinho. O Avance cuida da agenda e do financeiro pra você focar no paciente.',
      icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
    },
    {
      title: 'Clínica com equipe',
      desc: 'Vários profissionais, vários procedimentos, uma agenda só. Cada um vê seus próprios horários e sua própria comissão.',
      icon: 'M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-2.13a4 4 0 100-8 4 4 0 000 8zm6 1a4 4 0 10-4-4',
    },
    {
      title: 'Rede com várias unidades',
      desc: 'Mais de uma clínica sob a mesma marca? Gerencie todas as unidades a partir de um único painel.',
      icon: 'M3 21h18M5 21V7l8-4v18M13 21V11l6 3v7M9 9h.01M9 12h.01M9 15h.01',
    },
  ],

  faqSection: {
    eyebrow: 'FAQ',
    title: 'Dúvidas comuns de quem toca uma clínica de estética',
  },

  faq: [
    {
      q: 'Meus profissionais veem só a agenda deles?',
      a: 'Sim. Cada profissional entra com seu próprio acesso e vê apenas os horários e pacientes que são dele. Quem administra a clínica tem a visão completa de todas as agendas.',
    },
    {
      q: 'Funciona para clínica com mais de uma unidade?',
      a: 'Funciona. Você cadastra cada unidade dentro da mesma conta e acompanha todas a partir de um único painel, sem precisar de um sistema separado por endereço.',
    },
    {
      q: 'Meus pacientes agendam procedimentos pelo celular, sem falar comigo no WhatsApp?',
      a: 'Sim. Sua clínica ganha um link próprio de agendamento onde o paciente escolhe unidade, profissional, procedimento e horário direto do celular, sem precisar te chamar.',
    },
    {
      q: 'O sistema calcula a comissão dos profissionais automaticamente?',
      a: 'Sim. Você configura a regra de comissão de cada profissional e o sistema soma automaticamente com base nos atendimentos e vendas realizados.',
    },
    {
      q: 'Consigo ver quanto minha clínica faturou no mês?',
      a: 'Consegue. O dashboard mostra receita, ticket médio, atendimentos e quais procedimentos mais dão retorno, com relatórios exportáveis para conferir quando quiser.',
    },
    {
      q: 'Já tenho meus pacientes numa planilha, dá pra importar?',
      a: 'Dá. O Avance importa sua lista de pacientes a partir de um arquivo CSV, então você não perde o histórico que já tinha.',
    },
    {
      q: 'Meu paciente já consegue pagar o procedimento pelo link de agendamento?',
      a: 'Ainda não — o pagamento integrado ao agendamento está no roadmap. Hoje o paciente marca o horário online e o pagamento é feito normalmente na clínica.',
    },
    {
      q: 'Meus dados e os dos meus pacientes ficam protegidos conforme a LGPD?',
      a: 'Sim. O Avance segue a LGPD, com exportação e possibilidade de solicitar exclusão dos dados, além de termos de uso e política de privacidade claros.',
    },
    {
      q: 'Como funciona o suporte se eu tiver dúvida usando o sistema?',
      a: 'É só chamar a gente pelo WhatsApp ou e-mail de contato — te ajudamos a configurar sua clínica e tirar dúvidas do dia a dia.',
    },
  ],

  plans: {
    eyebrow: 'Planos',
    title: 'Comece agora com o Avance',
    subtitle:
      'Escolha o plano ideal para a sua clínica e comece a organizar a agenda e o financeiro ainda hoje.',
  },

  midCta: {
    title: 'Viu tudo que o Avance faz? Agora é só colocar pra rodar.',
    subtitle: 'Fale com a gente e comece a organizar sua clínica ainda hoje.',
    primaryCta: 'Comece agora',
  },

  finalCta: {
    title: 'Ainda está com dúvidas? Fale com a gente.',
    subtitle: 'Agende uma demonstração e descubra o novo aliado da sua clínica',
    primaryCta: 'Fale com a gente',
  },

  signupCopy: {
    modalDescription: 'Leva menos de 2 minutos para colocar sua clínica no Avance.',
    businessNamePlaceholder: 'Ex: Clínica Bella Estética',
  },
}
